import { IAjaxConfig } from '../helpers';
/**
 *  订单 API 地址
 *  @swagger http://bpportalordersit.earth.xpaas.lenovo.com/swagger-ui.html#/
 */
export class EnumApiSecOrders {
  /**
   * @dec SEC列表
   */
  readonly sec_orders_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/sec/order/search ',
    method: 'post',
  };

  /**
   * @dec SEC详情-获取商品详情 状态1和5除外的其他
   */
  readonly sec_orders_details: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerorder/order/detail',
    method: 'post',
  };

  /**
   * @dec SEC详情-获取商品详情 状态1和5除外的其他
   */
  readonly sec_confirm: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/sec/order/confirm',
    method: 'post',
  };
}
